import { render, staticRenderFns } from "./share-dialog.vue?vue&type=template&id=3a77d8df&scoped=true&"
import script from "./share-dialog.vue?vue&type=script&lang=js&"
export * from "./share-dialog.vue?vue&type=script&lang=js&"
import style0 from "./share-dialog.vue?vue&type=style&index=0&id=3a77d8df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a77d8df",
  null
  
)

export default component.exports